import { CommandType } from "../../../../common/services/cqs/CommandType";
import { AtgardNaturvardesbedomningDTO } from "../../models/naturvardesbedomning-models";
import { AtgardNaturvardesbedomningCommandBase } from "./AtgardNaturvardesbedomningCommandBase";

export class UpdateAtgardNaturvardesbedomningCommand extends AtgardNaturvardesbedomningCommandBase {
    readonly naturvardesbedomning: AtgardNaturvardesbedomningDTO;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateAtgardNaturvardesbedomningCommand";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Naturvardesbedomning";

    constructor(naturvardesbedomning: AtgardNaturvardesbedomningDTO, atgardGuid: string) {
        super(atgardGuid, UpdateAtgardNaturvardesbedomningCommand.$type, CommandType.Replace);
        this.naturvardesbedomning = naturvardesbedomning;
    }
}
